import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import ParentPage from '../pages/ParentPage.vue'
import ChildPage from '../pages/ChildPage.vue'

import { store } from '../main'
import {
  EventBus,
  initStateData,
  updateWPEditButton,
  setActiveMenuItem
} from '../utils'

Vue.use(VueRouter)

/**
 * "Converts" component strings to real components.
 * Since these where defined server-side, they had to be strings.
 */
;(initStateData.routes as any).forEach((route: any) => {
  switch (route.component) {
    case 'ChildPage':
      route.component = ChildPage
      break
    case 'ParentPage':
      route.component = ParentPage
      break
  }
})

// Routes
const routes: Array<RouteConfig> = initStateData.routes

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

/**
 * Before the route is updated.
 * Before a new page is displayed within the app
 */
router.beforeEach((to, from, next) => {
  if (from.name !== to.name) {
    EventBus.$emit('hide-hero')
    setTimeout(() => {
      next()
    }, 300)
  } else next()
})

/**
 * After the route is updated.
 * After a new page is displayed within the app.
 */

router.afterEach(to => {
  // Set new src for wp admin bars Edit button
  updateWPEditButton(to)
  Vue.nextTick(() => {
    const item: any = store.state.routes.find(
      (item: any) => item.path === to.path
    )
    if (item) document.title = item.title_tag

    // Scroll to the page top
    EventBus.$emit('scroll-to-top')

    // Lazy load - Update for detecting the new pages images.
    setTimeout(() => {
      ;(window as any).lazyLoadInstance.update()
    }, 700)

    // Preoad sibling hero images
    store.dispatch({ type: 'preLoadHeroes', payload: { to: to.name } })
  })
})

export default router
